// extracted by mini-css-extract-plugin
export default {"redesignIssueBox":"btRQyWSplRPJjyHr8xqA","redesignIssueWarning":"ULq3AHR7uZ36wFE7ikYI","redesignIssueError":"HVVKmyCnDfvnQTSaaiCs","redesignIssueIcon":"fooG1KzTNxLEKeT3fwws"};